import { Checkbox } from '@digdir/designsystemet-react';
import { useFormContext } from 'react-hook-form';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { StyledCard } from '../../../../../../../../components/registering/steps/base/form/detailingSelect/components/styledComponents';
import { CardContentWrapper } from '../../../../../solceller/form/components/styledComponents';
import { OppvarmingFormData } from '../../../../types';
import { VarmesentralRadio } from '../../common/varmesentralRadio';
import { ServiceSisteToArRadio } from '../../common/serviceSisteToArRadio';
import { VarmesystemBrukCheckboxes } from '../../common/varmesystemBruk';
import { useBioenergiValidation } from '../useBioenergiValidation';
import { InstallertIOppvarmetRomRadio } from '../../common/installertIOppvarmetRomRadio';
import { InstallasjonsArRadio } from '../../../../../../components/installasjonsArRadio';

import { Fordelingssystem } from './fordelingssystem';

export const BiokjelCheckbox = () => {
  const { register, watch, formState } = useFormContext<OppvarmingFormData>();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming' });
  const { validateBioenergiSelection } = useBioenergiValidation();

  const biokjelSelected = watch('bioenergi.value.kjel.selected');
  const oppvarmingBrukSelection = watch(`bioenergi.value.kjel.value.bruk`);
  const showVarmesentral = oppvarmingBrukSelection?.romoppvarming;

  const error = formState.errors?.bioenergi?.value?.kjel?.selected;

  return (
    <StyledCard isActive={biokjelSelected}>
      <CardContentWrapper>
        <Checkbox
          aria-invalid={!!error}
          label={t('bioenergi.biokjel.label')}
          {...register('bioenergi.value.kjel.selected', {
            validate: validateBioenergiSelection,
            deps: ['bioenergi.value.kamin.selected', 'bioenergi.value.kaminMedVannbarenVarme.selected'],
            shouldUnregister: true
          })}
        />
        {biokjelSelected && (
          <Fragment>
            <InstallasjonsArRadio
              name={`bioenergi.value.kjel.value.varmesentral`}
              translationKeyPrefix={`form.oppvarming.bioenergi.biokjel.varmesentral.installasjonsAr`}
            />
            <VarmesentralRadio name="bioenergi.value.kjel.value.varmesentral.varmesentralType" />
            <InstallertIOppvarmetRomRadio name="bioenergi.value.kjel.value.varmesentral.installertIOppvarmetRom" />

            <InstallasjonsArRadio
              name={`bioenergi.value.kjel.value`}
              translationKeyPrefix={`form.oppvarming.bioenergi.biokjel.installasjonsAr`}
            />

            <ServiceSisteToArRadio name="bioenergi.value.kjel.value.serviceGjennomfortSiste2Ar" />

            <VarmesystemBrukCheckboxes name="bioenergi.value.kjel.value.bruk" />

            {showVarmesentral && <Fordelingssystem />}
          </Fragment>
        )}
      </CardContentWrapper>
    </StyledCard>
  );
};
